(function(window, $) {
	// slider top
	$('.heading__slider').slick({
		autoplay: true,
		autoplaySpeed: 4000,
		dots: true,
		arrows: false
	});

	// slider bottom
	var expertiseSliderFront = $('.expertise__slider-front__items'),
		expertiseSliderBack = $('.expertise__slider-back');
	expertiseSliderFront.on('init', function(event, slick) {
		var totalSlides = expertiseSliderFront.find('.slick-slide:not(.slick-cloned)').length;
		expertiseSliderFront.parent().find('.paging .of').text(totalSlides);
	});
	expertiseSliderFront.on('afterChange', function(event, slick, currentSlide, nextSlide){
		expertiseSliderFront.parent().find('.paging .index').text(currentSlide+1);
	});
	expertiseSliderFront.slick({
		appendArrows: '.expertise__slider-front__nav .arrows',
		asNavFor: '.expertise__slider-back'
	});
	expertiseSliderBack.slick({
		accessibility: false,
		arrows: false,
		swipe: false,
		touchMove: false,
		fade: true,
		asNavFor: '.expertise__slider-front__items'
	});

	//video
	$('#page-heading__video').on('click', function(e){
		e.preventDefault()
		console.log( $(this).attr('href') )
	})

})(window, jQuery);
